import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const TitleBar = props => {
    const { children, backLink, title } = props
    return (
        <div className="title-container">
            {backLink && (
                <div className="back">
                    <Link to={backLink}>
                        <i className="icon-back"></i>
                    </Link>
                </div>
            )}
            <h1>{title}</h1>
            <div className="options">{children}</div>
        </div>
    )
}

TitleBar.propTypes = {
    backLink: PropTypes.string,
    children: PropTypes.node,
    title: PropTypes.string.isRequired,
}

export { TitleBar }
